export const AUTHORIZED_ROOM_MODES = ['score']
export const AUTHORIZED_MAX_PLAYERS = [1, 2, 3, 4]